import { Card } from "@/components/ui/card";
import {
  Target,
  Users,
  TrendingUp,
  ClipboardCheck,
  ChevronRight,
  Presentation,
  Briefcase,
  GraduationCap,
} from "lucide-react";
import { Link } from "react-router-dom";
const programs = [
  {
    icon: ClipboardCheck,
    title:
      " Maxwell DISC Training for CPA Firms. Stronger Communication. Better Collaboration. A Smoother Busy Season.",
    description:
      "Give your team the tools to communicate clearly, reduce conflict, and perform at their best — especially under pressure.",
    duration: "",
    link: "/programs/cpa-firms",
  },
  {
    icon: ClipboardCheck,
    title: "Maxwell DISC Personality Assessment & Workshop",
    description:
      "Unlock the power of self-awareness and team synergy with the Maxwell DISC assessment. Discover your unique communication style, understand your team's dynamics, and learn strategies to connect, collaborate, and lead more effectively. Includes personalized reports and actionable coaching.",
    duration: "",
    link: "/programs/maxwell-disc",
  },
  {
    icon: Target,
    title: "Mastermind Groups",
    description:
      "Affordable, flexible, transformational. Focus areas: Growth, Leadership, Communication, Resilience. Packages starting at $79 + book purchase.",
    duration: "",
    link: "/programs/mastermind-groups",
  },
  {
    icon: Users,
    title: "Coaching",
    description:
      "Personalized one-on-one sessions (3, 6, or 12 packages). Weekly, semi-monthly, or monthly scheduling.",
    duration: "Customized programs",
    link: "/programs/coaching",
  },
  {
    icon: TrendingUp,
    title: "Organizational Leadership Development",
    description:
      "Customized programs for executives, sales leaders, and professional services firms. Includes communication workshops, coaching bootcamps, sales training, teamwork development, and ongoing assessments.",
    duration: "2-4 months",
    link: "/programs/organizational-leadership",
  },
  {
    icon: Presentation,
    title: "Workshops & Lunch-and-Learns",
    description:
      "Interactive sessions that energize teams and deliver practical tools for communication, leadership, sales, and collaboration. Perfect for organizations looking to inspire and upskill quickly.",
    duration: "",
    link: "/programs/workshops-lunch-learns",
  },
  {
    icon: Briefcase,
    title: "Entrepreneur & Sales Programs",
    description:
      "Designed for entrepreneurs and sales professionals, these sessions sharpen strategy, improve closing rates, and boost influence with clients. Practical tools to drive growth and results.",
    duration: "",
    link: "/programs/entrepreneur-sales",
  },
  {
    icon: GraduationCap,
    title: "College & Career Programs",
    description:
      "Guidance for students and professionals navigating career paths, interviews, and transitions. These programs build confidence, clarity, and readiness for the next step.",
    duration: "",
    link: "/programs/college-career",
  },
];
const Programs = () => {
  return (
    <section id="programs" className="py-20 bg-muted/30">
      <div className="container px-4 md:px-6 my-0 py-0">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-heading mb-4">Leadership Programs</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-normal">
            Tailored coaching solutions designed to meet you where you are and take you where you want to be
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-16 space-y-4 text-left">
          <p className="leading-relaxed my-0 py-0 text-[#3372ec] text-base font-bold">
            Our programs are holistic and inclusive — culturally responsive, experiential, and designed to align
            personal growth with professional success.
          </p>
          <ul className="space-y-3 text-muted-foreground">
            <li className="flex gap-3 text-gray-950">
              <span className="text-accent mt-1">•</span>
              <span>
                We develop the whole person — mindset, emotional intelligence, communication, and business acumen.
              </span>
            </li>
            <li className="flex gap-3 text-gray-950">
              <span className="text-accent mt-1">•</span>
              <span>
                We honor diverse backgrounds and leadership styles, creating safe, equitable spaces for growth.
              </span>
            </li>
            <li className="flex gap-3 text-gray-950">
              <span className="text-accent mt-1">•</span>
              <span>
                We use experiential learning — workshops, DISC assessments, role-playing, and real-world scenarios — so
                participants apply skills immediately.
              </span>
            </li>
            <li className="flex gap-3 text-gray-950">
              <span className="text-accent mt-1">•</span>
              <span>
                We help leaders connect personal growth with professional success, becoming the kind of leaders who
                shine from the inside out.
              </span>
            </li>
          </ul>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {programs.map((program, index) => (
            <Card key={index} className="p-8 border-border/50 flex flex-col">
              <div className="mb-6 w-14 h-14 rounded-lg flex items-center justify-center bg-[#fdb12d]">
                <program.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-heading">{program.title}</h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">{program.description}</p>

              <Link
                to={program.link}
                onClick={() => window.scrollTo(0, 0)}
                className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium mt-auto"
              >
                <ChevronRight className="w-5 h-5" />
                <span className="text-[#fdb12d]">Explore Program</span>
              </Link>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Programs;
